// flows/brandKitCreation/steps.ts
import { step, defineSteps } from 'flows/common/helpers/defineSteps'
import { BrandKit } from 'types'
import { shuffle } from 'lodash'
import { PALETTES } from 'constants/palettes'

import { BrandKitInstructions } from 'flows/common/steps/BrandKitInstructions/BrandKitInstructions'
import { BrandKitParent } from 'flows/common/steps/BrandKitForm/BrandKitParent'
import { BrandKitColorsAndFonts } from 'flows/common/steps/BrandKitColorsAndFonts/BrandKitColorsAndFonts'
import { BrandKitImages } from 'flows/common/steps/BrandKitImages/BrandKitImages'
import { BrandKitVoice } from 'flows/common/steps/BrandKitVoice/BrandKitVoice'
import { BASE_ASSET_URL } from 'flows/common/constants'

export const brandKitSteps = defineSteps([
  step('brandKitInstructions', BrandKitInstructions).allowSkip().withImage(`${BASE_ASSET_URL}/7.jpeg`),

  step('brandKitForm', BrandKitParent)
    .allowSkip()
    .withExtra((ctx) => ({
      onBrandKitGenerated: (bk: BrandKit) => {
        const websitePalette = bk.brand_visual_kit?.primary_color_palette?.colors.map((c) => c.hex) ?? []

        ctx.setColorPaletteState({
          websitePalette,
          generatedPalettes: shuffle(PALETTES).slice(0, 3),
          selectedPaletteIndex: 0,
        })

        const websitePairing = bk.brand_visual_kit?.text_styles ?? []
        ctx.setFontPairingState({
          websitePairing,
        })

        ctx.setBrandKit?.(bk)
      },
      colorPaletteState: ctx.colorPaletteState,
      setColorPaletteState: ctx.setColorPaletteState,
      fontPairingState: ctx.fontPairingState,
      setFontPairingState: ctx.setFontPairingState,
      withinOnboarding: true,
    })),

  step('brandKitColors', BrandKitColorsAndFonts)
    .allowSkip()
    .withExtra((ctx) => ({
      brandKit: ctx.brandKit,
      fontPairingState: ctx.fontPairingState,
      colorPaletteState: ctx.colorPaletteState,
      setColorPaletteState: ctx.setColorPaletteState,
      title: "Boom! Let's confirm your new Brand Kit! ✨",
    })),

  step('brandKitImages', BrandKitImages)
    .allowSkip()
    .withExtra((ctx) => ({
      brandKit: ctx.brandKit,
      title: 'We gave you head start with some of the images we found on your website.',
      withinOnboarding: true,
    })),

  step('brandKitVoice', BrandKitVoice)
    .allowSkip()
    .withExtra((ctx) => ({
      brandKit: ctx.brandKit,
      title: 'Review your Brand Voice',
    })),
])
